module.exports = __webpack_public_path__ + "static/img/exam-5-bg.4d87af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-5-bg.png
// module id = UvgV
// module chunks = 1